import React from "react";
import classes from "./heroSection.module.css";

const HeroSection = () => {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.leftSide}>
          <h2 className={classes.header}>Welcome to Cairo Finance Holding</h2>
          <p className={classes.para}>
            Cairo Capital is a premier financial institution with a legacy of
            over two decades, dedicated to delivering comprehensive financial
            solutions across Egypt and the MENA region. Established in 1995 as
            an asset management firm, it has since evolved into a diversified
            powerhouse, offering securities brokerage, asset management, private
            equity, and startup ventures.
          </p>
        </div>
        <div className={classes.rightSide}></div>
      </div>
    </>
  );
};

export default HeroSection;
